// extracted by css-extract-rspack-plugin
export default {"grid":"grid-uPIu6O","stat":"stat-rLU8aU","label":"label-RhQyf1","value":"value-hv9HlP","hint":"hint-srnXM_"};